import { CONSENT_ALL, getStoredConsent } from './cookieConsent';

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

const DATA_LAYER_SOFT_CAP = 200;

/**
 * Push a GTM / analytics event when the user has granted analytics consent.
 * Never throws; never blocks the UI on storage or dataLayer failures.
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return undefined;
  try {
    if (getStoredConsent() !== CONSENT_ALL) {
      return undefined;
    }
  } catch {
    return undefined;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    if (window.dataLayer.length > DATA_LAYER_SOFT_CAP) {
      window.dataLayer.splice(0, window.dataLayer.length - DATA_LAYER_SOFT_CAP);
    }
    const payload = {
      event: eventName,
      ...params,
      timestamp: new Date().toISOString(),
    };
    window.dataLayer.push(payload);
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console -- local analytics debug only
      console.log('[Analytics Event]', payload);
    }
    return payload;
  } catch {
    return undefined;
  }
};

if (typeof window !== 'undefined') {
  window.trackEvent = trackEvent;
}
